export const isTruncated = (el) => {
  return el.scrollWidth > el.clientWidth;
};
